<template>
  <li class="message-create-control">
    <profile-image class="profile-image me-2" :user="currentUser" size="md" />
    <text-create-form :placeholder="i18n.t('member.forums.write_your_comment')"
                      name="reply"
                      :button-text="i18n.t('member.forums.reply')"
                      size="md"
                      :create-action="createNewReply" />
  </li>
</template>

<script>
import ProfileImage from '@/components/members/profile-image'
import TextCreateForm from '@/components/inputs/text-create-form'
import { mapState } from 'vuex'

export default {
  components: { ProfileImage, TextCreateForm },

  props: {
    threadId: {
      type: Number,
      required: true
    }
  },

  computed: {
    ...mapState(['currentUser'])
  },

  methods: {
    createNewReply: function(content) {
      return this.$store.dispatch('createReply', {threadId: this.threadId, content})
    }
  }
}
</script>

<style lang="scss" scoped>
  @use "~common_styles/breakpoints" as breakpoints;

  .message-create-control {
    display: flex;
    align-items: flex-start;
    background-color: #F3F3F3;
    margin-bottom: 10px;
    padding: 10px;
  }

  @include breakpoints.screen-mobile-only {
    .profile-image {
      display: none;
    }
  }

</style>
